const truncateDescription = description =>
  description && description.length > 160
    ? `${description.substring(0, 160)}...`
    : description;

export default truncateDescription;
